// @flow
import React, {  Component } from 'react'; 
import classNames from 'classnames/bind';
import {Desktop, UntilTablet} from '../../../../utils/responsive';
import Slider from 'react-slick/lib'; 
import Discover from '../Discover/Discover';
import analytics from '../../../../analytics';
import PropTypes from 'prop-types';

import Step1 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-1.png';
import Step2 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-2.png';
import Step3 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-3.png';
import Step4 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-4.png';
import StepMobile1 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-mobile-1.png';
import StepMobile2 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-mobile-2.png';
import StepMobile3 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-mobile-3.png';
import StepMobile4 from '../../../../assets/img/home/how-it-works/stepper-how-it-works/step-mobile-4.png'; 

import style from './HowItWorks.scss'; 

import type {LocaleState} from '../../../locale/duck';
  
 
type Props = {
  +locale: LocaleState;
};

type State = {|
  slideIndex: number;
  url: {
    value: string;
    errors?: string[];
  };
  isBrowser: boolean;
  autoplayBannerCarousel: boolean;
|};

type Step = {|
  title: string;
  text: string;  
|};

const steps = [
  {
    title: '¿Qué producto quieres?',
    text: 'Busca el producto que quieres en la tienda donde deseas que se realice la compra',
  },
  {
    title: 'Estámos listos para tu solicitud ',
    text: 'Copia el link del producto y pégalo en Qempo para recibir la cotización total ',
  },
  {
    title: 'Realiza el pago',
    text: 'Aceptamos pagos con tarjeta de créditos (hasta 36 cuotas), débito, Paypal, depósito o transferencia bancaría y Bitcoins.',
  },
  {
    title: 'Espera tranquilo',
    text: 'Qempo se encargará de todo. No tendrás que hacer ningún trámite ni papeleo, solo esperar en la comodidad de tu casa. ',
  },
]

const desktopBanner =  [
  {
    step: 1,
    url: Step1,
  },
  {
    step: 2,
    url: Step2,
  },
  {
    step: 3,
    url: Step3,
  },
  {
    step: 4,
    url: Step4,
  },
];

const mobileBanner = [
  {
    step: 1,
    url: StepMobile1,
  },
  {
    step: 2,
    url: StepMobile2,
  },
  {
    step: 3,
    url: StepMobile3,
  },
  {
    step: 4,
    url: StepMobile4,
  },
];

const HEIGHT_TO_SCROLL = 500;

export default class HowItWorks extends Component<Props, State> {
  sliderBanner: Slider;
  sliderSteppers: Slider;
  
  constructor(props: Props) {
    super(props); 
    this.state = { 
      slideIndex: 0,
      url: {
        value: '',
      },
      isBrowser: false,
      autoplayBannerCarousel: false
    };
  }

  onScroll = () => {
    const { autoplayBannerCarousel } = this.state;
    
    if (window.scrollY > HEIGHT_TO_SCROLL && !autoplayBannerCarousel && this.sliderBanner) {
      this.setState({autoplayBannerCarousel: true}, () => {
        setTimeout(()=> {
          this.sliderBanner.slickPlay();
        }, 750);
      });
    }
  };

  componentDidMount() {
    document.addEventListener('scroll', this.onScroll);

    this.setState({
      isBrowser: true,
    });
  }

  componentWillUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  };

  fireHowItWorksEvent = () => {
    const {locale} = this.props;
    const {url} = this.state;

    analytics.fireCustomEvent('Home How It Works Button Clicked', {
      category: 'Home How It Works Button',
      action: 'Clicked',
      user_type: 'purchaser',
      user_referrer: window.localStorage.getItem('userReferrer') || '',
      landing_url: window.localStorage.getItem('landingUrl') || '',
      url: url.value || '',
      domain_country: locale.domainCountry,
    });
  };

  render() {
    const slidesToShow = 1; 
    const {url, isBrowser, slideIndex} = this.state;

    const options = {
      infinite: true,
      slidesToScroll: 1,
      dots: true,
      dotsClass: classNames('slick-dots', style.dots),
      arrows: false,
      draggable: true,
      autoplaySpeed: 5000,
      speed: 800,
      slidesToShow: slidesToShow,
      beforeChange: (current, next) => this.setState({ slideIndex: next })
    };

    const stepperOptions = {
      infinite: true,
      verticalSwiping: true,
      vertical: true,
      dots: false,
      arrows: false,
      draggable: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      adaptiveHeight: true,
    };

    const desktopSliders =  desktopBanner.map((item, index) => (
      <div  key={`step-banner-${index}`} className={style.slide}>
        <img src={item.url} alt="step" />
      </div>
    ));
    const mobileSliders =  mobileBanner.map((item, index) => (
      <div  key={`step-banner-mobile-${index}`} className={style.slide}>
        <img src={item.url} alt="step"/>
      </div>
    ));

    const carousel =  <div className={style.bannerCarousel}>
      <Desktop>
        <Slider
          ref={slider => (this.sliderBanner = slider)}
          {...options}
        >
          {desktopSliders}
        </Slider>
      </Desktop>      
      <UntilTablet>
        <Slider 
          ref={slider => (this.sliderBanner = slider)}
          asNavFor={this.sliderSteppers}
          {...options}
        >
          {mobileSliders}
        </Slider>
      </UntilTablet>  
      
      
    </div>

    const desktopStepperItems = steps.map((step: Step, index: number)=> (
      <div className={style.stepWrap} key={`step-desktop-${index}`}>
        <button onClick={e => this.sliderBanner.slickGoTo(index)} >
          <div className={`${slideIndex === index ? style.stepNumberActive: style.stepNumberInactive}`} >
            <div className={style.outerCircle}>
              <div className={style.innerCircle}>
                  <span className={style.insideContent} >{index + 1}</span>
              </div>
            </div>
          </div>
        </button>
        
        <div className={style.contentWrap}>
          <h6 className={style.title}>
            {step.title}
          </h6>
          <p className={style.text}>
            {step.text}
          </p>
          {steps.length -1 > index && (<hr className={style.lineDivider}/>) }
        </div>
      </div>
    ));

    const mobileStepperItems = steps.map((step: Step, index: number)=> (
      <div key={`step-mobile-${index}`}>
        <div className={style.stepWrap}>
          <button>
            <div className={`${slideIndex === index ? style.stepNumberActive: style.stepNumberInactive}`} >
              <div className={style.outerCircle}>
                <div className={style.innerCircle}>
                    <span className={style.insideContent} >{index + 1}</span>
                </div>
              </div>
            </div>
          </button>
          <div className={style.contentWrap}>
            <h6 className={style.title}>
              {step.title}
            </h6>
            <p className={style.text}>
              {step.text}
            </p>
          </div>
        </div>
      </div>
      
    ));

    const steppers = <div className={style.contentStepWrap}>
      <div  className={style.lineDashed} />
      <Desktop>
        {desktopStepperItems}
      </Desktop>
      <UntilTablet>
          <Slider
            ref={slider => (this.sliderSteppers = slider)}
            asNavFor={this.sliderBanner}
            {...stepperOptions}
          >
            {mobileStepperItems}
          </Slider>
      </UntilTablet>

    </div>;

    const playButton = 
      <div className={style.discoverWrap}>
        {isBrowser && <Discover url={'https://www.youtube.com/embed/41Vug0RLHiU?rel=&controls=0&showinfo=0&autoplay=1'}
                                color="lightBlue"
                                handleClick={this.fireHowItWorksEvent}/>}
      </div>;

    return (
      <section className={style.purchaseSteps}>
        <div className={style.mainWrap}>
          <div className={style.titleWrap}>
            <h1>¿Cómo funciona Qempo?</h1> 
            {playButton} 
          </div>
          <div className={style.howItWorksWrap}>
            <div className={style.steppersWrap}>
              {steppers}
            </div>
            <div className={style.carouselWrap}>
              <div className={style.contentWrap}>
              {carousel} 
              </div>
            </div>
          </div>
        </div>
      </section>)
  }
}

HowItWorks.propTypes = { 
  locale: PropTypes.object.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/home/elements/HowItWorks/HowItWorks.jsx